import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import CarListTable from './CarListTable';
import './CarList.css';
import Toolbar from './Toolbar';

import { withRouter } from 'react-router-dom';
import { QsHelper } from '../../../helpers';
import { Spin } from 'antd';

@withRouter
@inject('carsStore', 'filterStore')
@observer
export default class CarList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leadsStatusSummaryLoading: 'false',
      leadsLoading: 'false',
      leadsSummary: {},
      leadsStatusSummary: {},
      cars: [],
      resetFilter: 'false',
      initialLoading: false
    };

    this.defaultFilterStorePage = 'cars';
  }

  loadData() {
    const { carsStore } = this.props;
    this.setState({ initialLoading: true });
    const page = Number(window.localStorage.getItem(carsStore.cacheKey) || 1);
    carsStore
      .virtualLoad({ page })
      .then(response => {
        carsStore.virtualLoadBadges();
      })
      .finally(() => {
        this.setState({ initialLoading: false });
      });
  }

  componentWillMount() {
    const { filterStore, carsStore } = this.props;
    filterStore.setupPage(this.defaultFilterStorePage);

    let status = new QsHelper(this.props.location.search).get('status');
    if (status) {
      const querystring = new QsHelper(this.props.location.search).getQueryString();
      carsStore.setCacheKey({ pageView: 'carlist', querystring });
    } else {
      carsStore.setCacheKey({ pageView: 'carlist' });
    }
    const metaData = window.localStorage.getItem(carsStore.cacheKey);
    if (!metaData) {
      window.localStorage.setItem(carsStore.cacheKey, 1);
    }
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    const { filterStore, carsStore } = this.props;
    filterStore.switchToPage(this.defaultFilterStorePage);

    const prevStatus = new QsHelper(this.props.location.search).get('status');
    const status = new QsHelper(nextProps.location.search).get('status');
    if (status !== prevStatus) {
      if (status) {
        const querystring = new QsHelper(nextProps.location.search).getQueryString();
        carsStore.setCacheKey({ pageView: 'carlist', querystring });
      } else {
        carsStore.setCacheKey({ pageView: 'carlist' });
      }
      const metaData = window.localStorage.getItem(carsStore.cacheKey);
      if (!metaData) {
        window.localStorage.setItem(carsStore.cacheKey, 1);
      }
    }
  }

  componentDidMount() {
    const { filterStore } = this.props;
    // filterStore.reset();
    this.loadData();
    let status = new QsHelper(this.props.location.search).get('status');

    if (status) {
      if (status === 'shutdown') {
        filterStore.add('carStatus_filter', car => car.obdService === 'shutdown', undefined, { obdService: 'shutdown' });
      } else {
        filterStore.add('carStatus_filter', car => car.status === status, undefined, { status });
      }
      filterStore.apply();
    }
  }

  componentWillUnmount() {
    const { filterStore } = this.props;
    filterStore.remove('carStatus_filter');
    filterStore.apply();
  }

  componentDidUpdate(prevProps) {
    const { filterStore, carsStore } = this.props;
    const status = new QsHelper(this.props.location.search).get('status');
    const prevStatus = new QsHelper(prevProps.location.search).get('status');

    if (status !== prevStatus) {
      // filterStore.reset();
      if (status) {
        if (status === 'shutdown') {
          filterStore.add('carStatus_filter', car => car.obdService === 'shutdown', undefined, { obdService: 'shutdown' });
        } else {
          filterStore.add('carStatus_filter', car => car.status === status, undefined, { status });
        }
      } else {
        filterStore.remove('carStatus_filter');
      }
      filterStore.apply();
    }
  }

  onChangingPage = ({ page }, cb) => {
    const { carsStore } = this.props;
    carsStore.virtualLoad({ page });
  };

  onSortingPage = ({ page, sort, order }, cb) => {
    const { carsStore } = this.props;
    carsStore.setVirtualSortAndOrder({ sort, order });
    carsStore.virtualLoad({ page });
  };

  render() {
    const { carsStore } = this.props;
    const { initialLoading } = this.state;
    return (
      <div className="CarList">
        <Toolbar />
        <Spin spinning={!initialLoading && carsStore.virtualIsLoading}>
          <CarListTable
            loading={initialLoading}
            onClientExport={this.props.onClientExport}
            cars={carsStore.filtered}
            virtualCars={carsStore.virtualCars}
            virtualCarsCount={carsStore.virtualCarsCount}
            onChangingPage={this.onChangingPage}
            onSortingPage={this.onSortingPage}
          />
        </Spin>
      </div>
    );
  }
}
